__webpack_require__.p = "/planets-fact/";